var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Sample Componet "+_vm._s(_vm.testMsg))])])}
var staticRenderFns = []

export { render, staticRenderFns }